<template>
  <el-dialog
    id='handleClaimDialog'
    :title="title"
    @close="closeDialog"
    :visible.sync="isShow"
    :width="data&&data.businessNo?'1300px':'700px'"
    :close-on-click-modal='false'
    :close-on-press-escape='false'
  >
    <el-dialog
      width="500px"
      title="设置联系电话"
      :visible.sync="innerVisible"
      class="dialogInner_class"
      append-to-body>
      <el-form :model="phoneForm" ref="phoneForm" label-width="100px" v-loading='setPhoneLoading'>
        <el-form-item
          label="联系电话"
          prop="phone"
          :rules="phoneRules"
          class="phoneForm-style">
          <el-input v-model.trim="phoneForm.phone" autocomplete="off"></el-input>
        </el-form-item>
        <span class="complainTitle">提示：客户管家App/PC发起工单、处理问题件、发起理赔将优先带入此处设置的联系电话。</span>
        <div class="btnn">
          <el-button @click="resetPhoneForm('phoneForm')" plain>取消</el-button>
          <el-button type="primary" @click="submitPhoneForm('phoneForm')">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
    <div id="handleClaim" v-loading = 'loading'>
      <div style="width:620px" v-loading='phoneLoading'>
        <div class="info-title mb20">理赔信息</div>
        <el-form :model="ruleForm" :rules="rules" :inline="true" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="运单号" prop="waybillNo">
            <el-input v-model.trim="ruleForm.waybillNo" placeholder="请输入运单号" :disabled="waybillNoFlag"></el-input>
          </el-form-item>
          <el-form-item label="理赔类型" prop="indemnityType" label-width="110px">
            <el-select v-model="ruleForm.indemnityType" placeholder="请选择" :disabled="readOnlyFlag">
              <el-option :label="val.name" :value="val.value" v-for="val in indemnityType" :key="val.value" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物品类型" prop="indemnityGoodsType">
            <el-select v-model="ruleForm.indemnityGoodsType" placeholder="请选择" :disabled="readOnlyFlag">
              <el-option v-for="val in indemnityGoodsType" :key="val.value" :label="val.name" :value="val.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物品价值" prop="indemnityGoodsWorth" label-width="110px" class="moneyStyle">
            <!-- <el-input v-model.trim="ruleForm.indemnityGoodsWorth" :disabled="readOnlyFlag" type="number" placeholder="请输入"><i slot="suffix" style="font-style:normal;margin-right: 10px;color:#606266;">元</i></el-input> -->
            <el-input-number v-model="ruleForm.indemnityGoodsWorth" :precision="2" :step="0.01" :disabled="readOnlyFlag" placeholder="请输入" controls-position="right" style="width:180px"></el-input-number>
            <span style="width:20px">元</span>
          </el-form-item>
          <el-form-item label="理赔金额" prop="indemnityAmount" class="moneyStyle">
            <el-input-number v-model="ruleForm.indemnityAmount" :precision="2" :step="0.01" :disabled="readOnlyFlag" placeholder="请输入" controls-position="right" style="width:180px"></el-input-number>
            <span style="width:20px">元</span>
            <!-- <el-input v-model.trim="ruleForm.indemnityAmount" type="number" :disabled="readOnlyFlag" placeholder="请输入"><i slot="suffix" style="font-style:normal;margin-right: 10px;color:#606266;">元</i></el-input> -->
          </el-form-item>
          <el-form-item label="发起人电话" prop="sponsorTel" label-width="110px"  class="sponsorTel-style">
            <el-input v-model.trim="ruleForm.sponsorTel" placeholder="请输入" :disabled="readOnlyFlag" style="width:150px"></el-input>
            <el-button :disabled="waybillNoFlag || readOnlyFlag"  type="primary" plain style="margin-left:5px;padding-left:0;padding-right:0;width:50px" @click="settingPhone">设置</el-button>
          </el-form-item>
          <el-form-item label="收件人姓名" prop="receiveName">
            <el-input v-model.trim="ruleForm.receiveName" :placeholder="readOnlyFlag?'':'请输入收件人姓名'" maxlength="12" :disabled="readOnlyFlag"></el-input>
          </el-form-item>
          <el-form-item label="收件人电话" prop="receiveTel" label-width="110px">
            <el-input v-model.trim="ruleForm.receiveTel" :placeholder="readOnlyFlag?'':'请输入收件人电话'" :disabled="readOnlyFlag"></el-input>
          </el-form-item>
          <el-form-item label="收件地址" prop="receiveAddress" class="textArea-style">
            <el-input type="textarea" v-model.trim="ruleForm.receiveAddress" maxlength="100" rows='2' :disabled="readOnlyFlag" show-word-limit :placeholder="readOnlyFlag?'':'请输入收件地址'"></el-input>
          </el-form-item>
          <el-form-item label="理赔描述" prop="indemnityContent" class="textArea-style">
            <el-input type="textarea" v-model.trim="ruleForm.indemnityContent" maxlength="1000" rows='3' :disabled="readOnlyFlag" show-word-limit placeholder="请输入理赔原因"></el-input>
          </el-form-item>
          <el-form-item  label="图片" prop="img" class="img-form">
            <el-upload
              ref="upload"
              :disabled="readOnlyFlag"
              class="uploadImg"
              :class="{hide:showUpload}"
              action="/steward/web/indemnityHInforController/uploadIndemnityImg"
              list-type="picture-card"
              :limit="6"
              accept=".jpg,.jpeg,.png,.gif"
              :on-exceed="handleExceed"
              :headers="headers"
              :file-list="fileList"
              :before-upload="beforeAvatarUpload"
              :on-success="uploadSuccess"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove">
              <i class="el-icon-plus">上传照片</i>
            </el-upload>
            <span v-if="data.type && data.type !='start'&&showUpload && (!fileList || (fileList && fileList.length<1))" style="position: absolute;top: 0px;width: 100Px;">暂无图片</span>
            <div id="tar_box" contenteditable="" v-if="!readOnlyFlag && !showUpload" @input="focusTarBox"></div>
            <div class="el-upload__tip">支持jpg、jpeg、gif、png格式的图片，最多上传6张，支持复制粘贴上传</div>
          </el-form-item>
          
          <el-form-item label="备注内容" prop="remark" class="textArea-style remark" v-if="data&&data.businessNo&&(data.indemnityStatus == 1 || data.indemnityStatus == 3) && data.type && data.type=='deal'">
            <el-input type="textarea" v-model="remark" maxlength="1000" rows='3' @blur="removeErrorMsg" show-word-limit placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item label-width="0" class="form-btn" v-if="data&&!data.businessNo && data.type && data.type=='start'">
            <el-button @click="resetForm('ruleForm')">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" :disabled="saveDisabled">提交</el-button>
          </el-form-item>
          <el-form-item label-width="0" class="form-btn claimOrderSubmit"  v-if="data&&data.businessNo&&(data.indemnityStatus == 1 || data.indemnityStatus == 3) && data.type && data.type=='deal'">
           <el-button type="primary" @click="claimOrderSubmit('ruleForm')" :disabled='updateDisabled'>提交</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="timeline" v-if="data&&data.businessNo">
         <el-tabs v-model="activeLog" @tab-click="handleClick">
          <el-tab-pane label="理赔轨迹" name="first"></el-tab-pane>
          <el-tab-pane label="修改记录" name="second"></el-tab-pane>
        </el-tabs>
        <div  v-loading='logLoading'>
          <ul v-if="orderData.length > 0">
            <li class="timeline-item-first" v-for="(item, i) in orderData" :key="i">
              <template>
                <div class="timeline-item-time">
                  <h3>{{getDateTime(item['modifyTime'])}}</h3>
                  <p>{{getDateTime(item['modifyTime'], 1)}}</p>
                </div>
                <div class="timeline-item-color">
                  <i class="circle-icon"></i>
                </div>
                <div class="timeline-item-tail"></div>
                <div class="timeline-item-content">
                  <p v-if="activeLog === 'first'">
                    <span style="font-weight:600">{{getProcessInfo(item['title'])}}</span>
                    <span>({{getProcessInfo(item['subTitle'])}})</span>
                  </p>
                  <p v-else>
                    <span style="font-weight:600">{{getProcessInfo(item['subTitle'])}}</span>
                  </p>
                  <p v-if="item.content" v-html="getProcessInfotoList(item['content'])"></p>
                </div>
              </template>
            </li>
          </ul>
          <div v-else style="width: 467px;text-align: center;margin-top: 20px;">暂无数据</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import netAPI from '@/api';
// import util from '@/utils/util';
import { getStore } from '@/utils/localStorage';
import { getAfterOrderPromoterPhoneApi, updatePromoterPhoneApi } from '@/api/afterSaleService/eComAfterSaleMgr/afterSaleOrder';
export default {
  props: {
    data: {
      type: Object
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      saveDisabled: false,
      updateDisabled: false,
      indemnityGoodsType: [
        {
          name: '生活用品',
          value: '1'
        }, {
          name: '服饰鞋帽',
          value: '2'
        }, {
          name: '食品',
          value: '3'
        }, {
          name: '文件',
          value: '4'
        },
        {
          name: '数码产品',
          value: '5'
        },
        {
          name: '其他',
          value: '6'
        }], // 物品类型
      indemnityType: [
        {
          name: '破损',
          value: '1'
        },
        {
          name: '遗失',
          value: '2'
        },
        {
          name: '延误',
          value: '3'
        },
        {
          name: '其他',
          value: '4'
        }], // 理赔类型
      title: this.data.title || '发起理赔',
      isShow: this.value,
      loading: false,
      remark: '',
      headers: {
        'source': 'YTO-STEWARD',
        'jwt-token': getStore('stewoard-token')
      },
      dialogImageList: [],
      dialogImageListFlag: false,
      showUpload: false,
      fileList: [],
      ruleForm: {
        waybillNo: '',
        indemnityType: '',
        indemnityGoodsType: '',
        indemnityGoodsWorth: '',
        indemnityAmount: '',
        sponsorTel: '',
        receiveName: '',
        receiveTel: '',
        receiveAddress: '',
        indemnityContent: '',
        fileList: []
      },
      rules: {
        waybillNo: [
          { required: true, message: '请输入运单号', trigger: 'blur' },
          {
            pattern: /^(R02T|R02Z)?((Y|y)(T|t)[0-9a-zA-Z]{13}|[Dd]{2}[8-9][0-9]{15}|(G|g)8[0-9]{16}|(M|m)[0-9]{14}|[A-Za-z0-9]{10,13}|[6-9][0-9]{17}|(Y|y)[0-9]{12})$/,
            message: '请输入正确的运单号'
          },
          { max: 30, message: '运单号长度小于30个字符', trigger: 'blur' }
        ],
        indemnityType: [
          { required: true, message: '请选择理赔类型', trigger: 'change' }
        ],
        indemnityGoodsType: [
          { required: true, message: '请选择物品类型', trigger: 'change' }
        ],
        indemnityGoodsWorth: [
          { required: true, message: '请输入物品价值', trigger: 'change' },
          {
            validator(rule, value, callback) {
              var reg = /^\d{1,7}(?:\.\d{1,2})?$/;
              if (!value) {
                callback(
                  new Error('请输入大于0小于1000万不超过两位小数的数字')
                );
              } else {
                if (reg.test(value)) {
                  // eslint-disable-next-line eqeqeq
                  if (value != 0) {
                    callback();
                  } else {
                    callback(
                      new Error('请输入大于0小于1000万不超过两位小数的数字')
                    );
                  }
                } else {
                  callback(
                    new Error('请输入大于0小于1000万不超过两位小数的数字')
                  );
                }
              }
            },
            trigger: 'blur'
          }
        ],
        indemnityAmount: [
          { required: true, message: '请输入理赔金额', trigger: 'change' },
          {
            validator(rule, value, callback) {
              var reg = /^\d{1,7}(?:\.\d{1,2})?$/;
              if (!value) {
                callback(
                  new Error('请输入大于0小于1000万不超过两位小数的数字')
                );
              } else {
                if (reg.test(value)) {
                  // eslint-disable-next-line eqeqeq
                  if (value != 0) {
                    callback();
                  } else {
                    callback(
                      new Error('请输入大于0小于1000万不超过两位小数的数字')
                    );
                  }
                } else {
                  callback(
                    new Error('请输入大于0小于1000万不超过两位小数的数字')
                  );
                }
              }
            },
            trigger: 'blur'
          }
        ],
        sponsorTel: [
          { required: true, message: '请输入发起人电话', trigger: 'change' },
          {
            validator(rule, value, callback) {
              let reg1 = /^([1]\d{10})$/;
              let reg2 = /^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8}))$/;
              if (
                (!(reg1.test(value)) && !(reg2.test(value))) &&
                value !== ''
              ) {
                return callback(new Error('格式不正确，请输入手机号或座机号'));
              }
              callback();
            },
            trigger: 'blur'
          }
        ],
        receiveName: [
          { required: true, message: '请输入收件人姓名', trigger: 'change' }
        ],
        receiveTel: [
          { required: true, message: '请输入收件人电话', trigger: 'change' },
          {
            validator(rule, value, callback) {
              let reg1 = /^([1]\d{10})$/;
              let reg2 = /^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8}))$/;
              if (
                (!(reg1.test(value)) && !(reg2.test(value))) &&
                value !== ''
              ) {
                return callback(new Error('格式不正确，请输入手机号或座机号'));
              }
              callback();
            },
            trigger: 'blur'
          }
        ],
        receiveAddress: [
          { required: true, message: '请输入收件地址', trigger: 'change' }
        ],
        indemnityContent: [
          { required: true, message: '请输入理赔原因', trigger: 'change' }
        ]
      },
      activeLog: 'first',
      orderData: [],
      logLoading: false,
      waybillNoFlag: false,
      readOnlyFlag: false,
      createMobile: '',
      innerVisible: false,
      setPhoneLoading: false,
      phoneLoading: false,
      phoneForm: {
        phone: ''
      },
      phoneRules: [
        { required: true, message: '请输入联系电话', trigger: 'blur' },
        {
          validator(rule, value, callback) {
            let reg1 = /^([1]\d{10})$/;
            let reg2 = /^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8}))$/;
            if (
              (!(reg1.test(value)) && !(reg2.test(value))) &&
              value !== ''
            ) {
              return callback(new Error('格式不正确，请输入手机号或座机号'));
            }
            callback();
          },
          trigger: 'blur'
        }
      ]
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  mounted() {
    if (this.data.businessNo) {
      // eslint-disable-next-line eqeqeq
      if (this.data.indemnityStatus != 1 && this.data.indemnityStatus != 3 && (this.data.type == 'deal' || this.data.type == 'show')) {
        this.readOnlyFlag = true;
        this.showUpload = true;
      }
      this.queryIndemnityTraceRecord();
      this.getIndemnityDetailByNo();
      this.waybillNoFlag = true;
    } else {
      // 刷新页面手机号
      this.refreshPhone();
    }

    let _this = this;
    document.addEventListener('paste', function (event) {
      if(event.target.id=='tar_box'){
        let isChrome = false;
        if (event.clipboardData || event.originalEvent) {
          //not for ie11  某些chrome版本使用的是event.originalEvent
          let clipboardData = (event.clipboardData || event.originalEvent.clipboardData);
          if (clipboardData.items) {
            // for chrome
            let items = clipboardData.items,
                len = items.length,
                blob = null;
            isChrome = true;
            //items.length比较有意思，初步判断是根据mime类型来的，即有几种mime类型，长度就是几（待验证）
            //如果粘贴纯文本，那么len=1，如果粘贴网页图片，len=2, items[0].type = 'text/plain', items[1].type = 'image/*'
            //如果使用截图工具粘贴图片，len=1, items[0].type = 'image/png'
            //如果粘贴纯文本+HTML，len=2, items[0].type = 'text/plain', items[1].type = 'text/html'
            //阻止默认行为即不让剪贴板内容在div中显示出来
            event.preventDefault();
            //在items里找粘贴的image,据上面分析,需要循环
            for (let i = 0; i < len; i++) {
              if (items[i].type.indexOf("image") !== -1) {
                blob = items[i].getAsFile();
              }
            }
            if (blob !== null) {
              let reader = new FileReader();
              reader.onload = function (event) {
                // event.target.result 即为图片的Base64编码字符串
                let base64_str = event.target.result
                //可以在这里写上传逻辑 直接将base64编码的字符串上传（可以尝试传入blob对象，看看后台程序能否解析）
                _this.uploadImgFromPaste(base64_str, 'paste', isChrome);
              }
              reader.readAsDataURL(blob);
            }
          } else {
            //for firefox
            setTimeout(function () {
              //设置setTimeout的原因是为了保证图片先插入到div里，然后去获取值
              let imgList = document.querySelectorAll('#tar_box img'),
                len = imgList.length,
                src_str = '',
                i;
              for (i = 0; i < len; i++) {
                if (imgList[i].className !== 'my_img') {
                  //如果是截图那么src_str就是base64 如果是复制的其他网页图片那么src_str就是此图片在别人服务器的地址
                  src_str = imgList[i].src;
                }
              }
              _this.uploadImgFromPaste(src_str, 'paste', isChrome);
            }, 1);
          }
        } else {
          //for ie11
          setTimeout(function () {
            let imgList = document.querySelectorAll('#tar_box img'),
              len = imgList.length,
              src_str = '',
              i;
            for (i = 0; i < len; i++) {
              if (imgList[i].className !== 'my_img') {
                src_str = imgList[i].src;
              }
            }
            //调用上传方法
            _this.uploadImgFromPaste(src_str, 'paste', isChrome);
          }, 1);
        }
      }
    })
  },
  methods: {
    focusTarBox(){
      document.getElementById('tar_box').innerHTML = '';
    },
     /**调用element的上传方法 需要把base64转换成file上传**/
    uploadImgFromPaste(file, type, isChrome) {
      if(this.showUpload || this.readOnlyFlag){
        return false;
      }
      if (this.dialogImageList.length >= 6) {
        this.$message.warning(`最多可以选择 6 个文件`);
        return false;
      }
      let a = this.dataURLtoBlob(file);
      let b = this.blobToFile(a);
      const upload = this.$refs.upload;
      upload.handleStart(b);
      this.$nextTick(()=>{
        upload.submit();
      })
    },
    /**
     * 将base64转换为blob
     */
    dataURLtoBlob (dataurl) {
      var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    /**
   * 将blob转换为file
   */
    blobToFile  (theBlob, fileName = 'ocr1.jpeg') {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },
    // 发起工单dialog打开时获取手机号
    getPromoterPhone() {
      return new Promise((resolve, reject) => {
        this.phoneLoading = true;
        getAfterOrderPromoterPhoneApi().then(res => {
          this.phoneLoading = false;
          resolve(res);
        }).catch(() => {
          this.phoneLoading = false;
          this.createMobile = this.userMess.mobile;
        });
      });
    },
    // 设置联系电话dialog打开时获取手机号
    settingPhone() {
      this.innerVisible = true;
      this.setPhoneLoading = true;
      getAfterOrderPromoterPhoneApi().then(res => {
        if (res.message === 'ok') {
          this.phoneForm.phone = res.data || '';
        } else {
          this.phoneForm.phone = '';
        }
        this.setPhoneLoading = false;
      }).catch(() => {
        this.phoneForm.phone = '';
        this.setPhoneLoading = false;
      });
    },
    // 设置联系电话dialog提交
    submitPhoneForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updatePromoterPhoneApi(this.phoneForm.phone).then(res => {
            if (res.message === 'ok') {
              this.$message.success('设置成功');
              this.innerVisible = false;
              // 刷新页面手机号
              this.refreshPhone();
            } else {
              this.$message.error(res.error || '设置失败');
            }
          }).catch(() => {
            this.$message.error('设置失败');
          });
        } else {
          return false;
        }
      });
    },
    // 设置联系电话dialog取消设置
    resetPhoneForm(formName) {
      this.$refs[formName].resetFields();
      this.innerVisible = false;
      // 刷新页面手机号
      this.refreshPhone();
    },
    // 刷新页面手机号
    refreshPhone() {
      this.getPromoterPhone().then((res) => {
        if (res.message === 'ok') {
          this.createMobile = res.data || this.userMess.mobile;
        } else {
          this.createMobile = this.userMess.mobile;
        }
      }).catch(() => {
        this.createMobile = this.userMess.mobile;
      }).finally(() => {
        this.ruleForm.sponsorTel = this.createMobile;
      });
    },
    // 备注信息
    removeErrorMsg() {
      if (this.remark === '') {
        let paramsCreat = {
          msg: '请输入备注',
          parentNode: '.remark .el-form-item__content',
          childNode: 'div',
          className: 'remarkError'
        };
        this.creatErrorDiv(paramsCreat);
      } else {
        var removeDiv = document.querySelector('.remarkError');
        var parentNodeReamrk = document.querySelector('.remark .el-form-item__content');
        if (removeDiv) {
          parentNodeReamrk.removeChild(removeDiv);
        }
      }
    },
    // 理赔工单详情
    getIndemnityDetailByNo() {
      netAPI.getIndemnityDetailByNo({
        indemnityNo: this.data.businessNo
      }).then(res => {
        if (res && res.success && res.data && res.data.data) {
          let {waybillNo, indemnityType, indemnityGoodsType, indemnityGoodsWorth, indemnityAmount, sponsorTel, receiveName, receiveTel, receiveAddress, indemnityContent, fileList} = res.data.data;
          this.ruleForm = {waybillNo, indemnityType, indemnityGoodsType, indemnityGoodsWorth, indemnityAmount, sponsorTel, receiveName, receiveTel, receiveAddress, indemnityContent, fileList};
          this.ruleForm.indemnityGoodsWorth = res.data.data.indemnityGoodsWorthStr;
          this.ruleForm.indemnityAmount = res.data.data.indemnityAmountStr;
          res.data.data.indemnityFileList.forEach(element => {
            let obj = {
              imgPath: element.path,
              imgFullPath: element.fullPath
            };
            let newobj = {
              url: element.fullPath
            };
            this.fileList.push(newobj);
            this.dialogImageList.push(obj);
          });
          if (this.fileList.length === 6) {
            this.showUpload = true;
          }
        }
      }).catch(() => {

      }).finally(()=>{
        if(this.waybillNoFlag){
          this.$refs.ruleForm.clearValidate(['sponsorTel']);
        }
        if(this.readOnlyFlag){
          this.$refs.ruleForm.clearValidate(['sponsorTel','receiveName','receiveTel','receiveAddress']);
        }
      });
    },
    // 处理理赔
    claimOrderSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialogImageList && this.dialogImageList.length > 0) {
            if (this.remark) {
              var removeDiv = document.querySelector('.remarkError');
              var parentNodeReamrk = document.querySelector('.remark .el-form-item__content');
              if (removeDiv) {
                parentNodeReamrk.removeChild(removeDiv);
              }
              var params = this.ruleForm;
              params.id = this.data.id;
              params.loginId = this.userMess.loginId;
              let imgList = [];
              this.dialogImageList.forEach(r => {
                imgList.push(r.imgPath);
              });
              params.fileList = imgList;
              params.remark = this.remark;
              params.branchCode = this.data.branchCode;
              params.indemnityStatus = this.data.indemnityStatus;
              this.updateDisabled = true;
              netAPI.indemnityUpdate(params).then(res => {
                this.updateDisabled = false;
                if (res.status === 0) {
                  this.$message.success('处理成功');
                  this.isShow = false;
                  this.$emit('close');
                  this.$emit('updataClaimList');
                } else {
                  this.$message.error(res.message);
                }
              }).catch(err => {
                this.updateDisabled = false;
                this.$message.error(err.message);
              });
            } else {
              let paramsCreat = {
                msg: '请输入备注',
                parentNode: '.remark .el-form-item__content',
                childNode: 'div',
                className: 'remarkError'
              };
              this.creatErrorDiv(paramsCreat);
            }
          } else {
            let paramsCreat = {
              msg: '请上传图片',
              parentNode: '.uploadImg',
              childNode: 'div',
              className: 'imgerro'
            };
            this.creatErrorDiv(paramsCreat);
          }
        } else {
          if (this.dialogImageList && this.dialogImageList.length === 0) {
            let paramsCreat = {
              msg: '请上传图片',
              parentNode: '.uploadImg',
              childNode: 'div',
              className: 'imgerro'
            };
            this.creatErrorDiv(paramsCreat);
          }
          return false;
        }
      });
    },
    // 提交发起理赔
    launchIndemnity(params) {
      if (this.dialogImageList && this.dialogImageList.length) {
        let imgList = [];
        this.dialogImageList.forEach(r => {
          imgList.push(r.imgPath);
        });
        params.fileList = imgList;
        params.source = 1;
        params.groupId = this.userMess.groupId;
        params.loginId = this.userMess.loginId;
      }
      this.saveDisabled = true;
      // 获取数据
      netAPI.launchIndemnity(params).then(res => {
        this.saveDisabled = false;
        if (res && res.success) {
          this.$message.success('发起理赔成功');
          this.isShow = false;
          this.$emit('close');
          this.$emit('updataClaimList');
        } else {
          this.$message.error(res.message);
        }
      }).catch(err => {
        this.saveDisabled = false;
        this.$message.error(err.message);
      });
    },
    handleClick(tab, event) {
      this.logLoading = true;
      // this.orderData = [];
      if (tab.name === 'first') {
        this.queryIndemnityTraceRecord();
      } else {
        this.queryIndemnityModifyRecord();
      }
    },
    queryIndemnityTraceRecord() {
      let params = {
        businessNo: this.data.businessNo
      };
      this.logLoading = true;
      this.orderData = [];
      netAPI.queryIndemnityTraceRecord(params).then(res => {
        if (res.status === 0) {
          if (res.data && res.data.length) {
            this.orderData = res.data;
          } else {
            this.orderData = [];
          }
        } else {
          this.orderData = [];
        }
        this.logLoading = false;
      }).catch((err) => {
        this.orderData = [];
        this.logLoading = false;
        console.log(err);
      });
    },
    queryIndemnityModifyRecord() {
      let params = {
        businessNo: this.data.businessNo
      };
      this.logLoading = true;
      this.orderData = [];
      netAPI.queryIndemnityModifyRecord(params).then(res => {
        if (res.status === 0) {
          if (res.data && res.data.length) {
            this.orderData = res.data;
          } else {
            this.orderData = [];
          }
        } else {
          this.orderData = [];
        }
        this.logLoading = false;
      }).catch((err) => {
        this.orderData = [];
        this.logLoading = false;
        console.log(err);
      });
    },
    // 上传前
    beforeAvatarUpload(file) {
      if (!/^image\/(jpeg|png|gif)$/.test(file.type)) {
        this.$alert('上传图片暂时只支持JPEG、JPG、PNG、GIF格式', '提示', {
          confirmButtonText: '关闭',
          type: 'error'
        });
        return false;
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$alert('图片大小5M以内', '提示', {
          confirmButtonText: '关闭',
          type: 'error'
        });
        return false;
      }
      return true;
    },
    // 上传成功
    uploadSuccess(res, file, fileList) {
      let removeDiv = document.querySelector('.imgerro');
      let eliconplus = document.querySelector('.uploadImg');
      if (removeDiv) {
        eliconplus.removeChild(removeDiv);
      }
      if (fileList.length >= 6) {
        // 上传图片大于等于6张时隐藏上传按钮
        this.showUpload = true;
      }
      this.dialogImageList.push({uid: file.uid, imgFullPath: res.data.imgFullPath, imgPath: res.data.imgPath});
      this.picId = res.id;
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    handleRemove(file, fileList) {
      if (fileList.length < 6) {
        // 上传图片小于6张时展示上传按钮
        this.showUpload = false;
      }
      for (var i = 0; i < this.dialogImageList.length; i++) {
        if (this.dialogImageList[i].uid) {
          // eslint-disable-next-line eqeqeq
          if (this.dialogImageList[i].uid == file.uid) {
            this.dialogImageList.splice(i, 1);
          }
        } else {
          // eslint-disable-next-line eqeqeq
          if (this.dialogImageList[i].imgFullPath == file.url) {
            this.dialogImageList.splice(i, 1);
            break;
          }
        }
      }
      this.dialogImageList = [...this.dialogImageList];
    },
    handlePictureCardPreview(file) {
      this.$parent.dialogImageUrl = file.url;
      this.$parent.dialogVisible = true;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多可以选择 6 个文件`);
    },
    imgPreview(item) {
      this.$parent.dialogImageUrl = item;
      this.$parent.dialogVisible = true;
    },
    closeDialog() {
      this.isShow = false;
      this.$emit('close');
    },
    creatErrorDiv({msg, parentNode, childNode, className}) {
      let eliconplus = document.querySelector(parentNode);
      var errordiv = document.createElement(childNode);
      errordiv.setAttribute('class', `el-form-item__error ${className}`);
      var node = document.createTextNode(msg);
      errordiv.appendChild(node);
      eliconplus.appendChild(errordiv);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialogImageList && this.dialogImageList.length > 0) {
            this.launchIndemnity(this.ruleForm);
          } else {
            let paramsCreat = {
              msg: '请上传图片',
              parentNode: '.uploadImg',
              childNode: 'div',
              className: 'imgerro'
            };
            this.creatErrorDiv(paramsCreat);
          }
        } else {
          if (this.dialogImageList && this.dialogImageList.length === 0) {
            let paramsCreat = {
              msg: '请上传图片',
              parentNode: '.uploadImg',
              childNode: 'div',
              className: 'imgerro'
            };
            this.creatErrorDiv(paramsCreat);
          }
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.closeDialog();
    },
    getDateTime(date, num = 0) {
      if (!date) return false;
      let dateArray = date.split(' ');
      let returnTxt = '';
      if (num) {
        returnTxt = dateArray[num].slice(0, 8);
      } else {
        returnTxt = dateArray[num];
      }
      return returnTxt;
    },
    getProcessInfo(text) {
      let returnTxt = '';
      if (text) {
        returnTxt = text;
      }
      return returnTxt;
    },
    getProcessInfotoList(text) {
      let returnTxt = '';
      if (text) {
        let arr = text.split('yto-yto');
        returnTxt = arr.filter(Boolean).join('</br>');
      }
      return returnTxt;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss">
@import '../../../styles/variables';

#handleClaimDialog{
  .el-dialog__body{
    padding: 40px;
  }
  .el-form-item--small.el-form-item{
    margin-bottom: 27px;
  }
  .claimOrderSubmit{
    margin-top: 20px;
    text-align: right;
  }
  .dialogInner_class{
    .phoneForm-style{
      width: 400px;
    }
    .el-button--small {
      width: 80px;
    }
    .complainTitle{
      font-size: 13px;
      color: #999;
    }
    .btnn {
      display: flex;
      width:"100%";
      justify-content: center;
      margin-top: 20px;
    }
  }
}
#handleClaim{
  display: flex;
  *{
    box-sizing: border-box;
    justify-content: center;
  }
  .info-title{
    padding-left: 8px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    &::before{
      content: '';
      width: 2px;
      height: 14px;
      background: $blue-style;
      border-radius: 1px;
      position: absolute;
      left: 40px;
    }
  }
  .demo-ruleForm{
    .el-form-item{
      margin-right: 0;
    }
    /deep/.el-form-item__label{
      padding-right: 8px;
    }
    .el-select, .el-input{
      width: 200px;
    }
    .textArea-style {
      width: 100%;
      .el-textarea{
        width: 515px;
      }
    }
    .moneyStyle{
      .el-form-item__content{
        width: 200px;
        .el-input{
          width: 180px;
        }
      }
    }
    .sponsorTel-style{
      display: inline-flex;
      .el-form-item__content{
        width: 200px;
        display: flex;
        justify-content: flex-start;
        .el-input{
          width: 150px;
        }
      }
    }
    .form-btn{
      display: block;
      margin-left: 0;
      text-align: center;
    }
  }
  .uploadImg{
    max-height: 60px;
    margin-bottom: 10px;
    .el-upload{
      width: 60px;
      height: 60px;
      line-height: 62px;
    }
    .el-upload-list{
      width: 60px;
      height: 60px;
    }
    .el-upload-list--picture-card .el-upload-list__item{
      width: 60px;
      height: 60px;
      margin-bottom: 0;
    }
    .el-upload-list--picture-card .el-upload-list__item-status-label {
      right: -18px;
      top: -16px;
      width: 40px;
      height: 35px;
    }
    .el-upload-list--picture-card .el-upload-list__item-status-label i {
      margin-top: 20px;
    }
    .el-upload-list__item-actions i {
      font-size: 16px;
    }
    .el-upload-list--picture-card .el-upload-list__item-actions span+span{
      margin-left: 10px;
    }
    .el-icon-plus{
      font-size: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      &::before{
        font-size: 20px;
        margin-bottom: 5px;
      }
    }
  }
  .hide .el-upload--picture-card {
    display: none;
  }
  .img-form{
    margin-bottom: 5px !important;
  }
  .img-form .el-form-item__label:before,.textArea-style .el-form-item__label:before{
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }
  .el-upload__tip{
    margin-left: 100px;
    margin-bottom: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
  }
  .img-form{
    .el-form-item__content{
      display: inline-flex;
      margin-left: 0!important;
      width: calc(100% - 100px);
      flex-wrap: wrap;
      justify-content: flex-start;
    }
    .el-upload__tip{
      align-self: flex-end;
      margin-left: 8px;
    }
  }
  #tar_box{
    width: 60px;
    height: 60px;
    display: inline-block;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    margin-left: 8px;
    box-sizing: border-box;
    &::before{
      content: '\590d\5236\7c98\8d34';//复制粘贴
      width: 60px;
      display: block;
      text-align: center;
      font-size: 12px;
      line-height: 60px;
      color: #8c939d;
    }
    &:focus{
      outline:1px dashed $blue-style;
    }
  }
}

.mt10{
  margin-top: 10px;
}
.ml10{
  margin-left: 10px;
}
.mr10{
  margin-right: 10px;
}
.mb20{
  margin-bottom: 20px;
}
#handleClaim .el-button--small {
  width: 100px;
}
.dialog_class {
  .dialog {
    .el-dialog__body {
      min-height: 60vh !important;
    }
  }
}
#handleClaim{
  .timeline {
    flex-shrink: 0;
    margin-left: 40px;
    padding-left: 40px;
    border-left: 1px solid #DCDFE6;

    .orderInfo {
      margin-bottom: 20px;
      padding-left: 40px;
    }
    ul {
      max-height: 300px;
      overflow: auto;
      padding: 0;
    }
    li {
      list-style: none;
      position: relative;
      overflow: hidden;
      padding-bottom: 10px;
      .timeline-item-content {
        width: 310px;
        p {
          text-align: left;
        }
        .view-icon{
          width: 35px;
          height: 24px;
          background: url('./../../../assets/images/im/icon_duihua@2x.png');
          background-repeat: no-repeat;
          margin-left: 4px;
          cursor: pointer;
          background-size: contain;
        }
      }
      &:first-child {
        .timeline-item-tail {
          top: 2px;
        }
        .timeline-item-color {
          border-color: $blue-style;
        }
        .circle-icon {
          background-color: $blue-style;
        }
        .timeline-item-content {
          width: 310px;
          p {
            text-align: left;
            color: $blue-style !important;
          }
        }
        .timeline-item-time {
          h3 {
            color: $blue-style !important;
          }
          p {
            color: $blue-style !important;
          }
        }
      }
    }
  }
  .timeline-item-color {
    border: 2px solid #dcdfe6;
    left: 112px;
    top: 2px;
    position: absolute;
    content: '';
    z-index: 99;
    border-radius: 99px;
  }
  .timeline-item-tail {
    position: absolute;
    content: '';
    height: 100%;
    width: 2px;
    left: 118px;
    top: 0;
    background-color: #dcdfe6;
  }
  .circle-icon {
    width: 10px;
    height: 10px;
    background-color: #dcdfe6;
    display: block;
    border-radius: 99px;
    border: 2px solid #fff;
}
  .timeline-item-time {
    width: 100px;
    float: left;
    h3 {
      margin: 0;
      padding: 0;
      text-align: right;
      font-weight: lighter;
      color: #a2a5ac;
    }
    p {
      margin: 0;
      text-align: right;
      color: #a2a5ac;
    }
  }
  .timeline-item-content {
    float: left;
    margin-left: 40px;
    h3 {
      margin: 0;
      padding: 0;
      font-weight: 500;
      color: #a2a5ac;
    }
    p {
      margin-top: 5px;
      margin-bottom: 10px;
      text-align: right;
      color: #a2a5ac;
    }
  }
}
.flex{
  display: flex;
}
</style>
